const role_management_en = {
  per_config:'per configuration',
  edit_role_info:'edit role information',
  del_role:'Delete role',
  permissions_error:'Please select the permissions to be configured',
  empty_role_name:'Please enter role name',
  empty_super_role:'Please select superior role',
  empty_alias:'Please enter an alias'
}

export default role_management_en



// WEBPACK FOOTER //
// ./src/common/lang/role_management/role_management_en.js